import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Input, Row } from "reactstrap";
import { departmentCityOptions } from "../../Home/SubSection/DepartmentCityOptions";
import JobType from "../../Home/SubSection/JobType";

const JobGridHeader = ({ setFilters }) => {
  const [companyName, setCompanyName] = useState("");
  const [department, setDepartment] = useState("");
  const [city, setCity] = useState("");
  const [jobType, setJobType] = useState({ label: "Seleccione una opción", value: null });

  const citiesForDepartment = department
    ? (departmentCityOptions.find((d) => d.departamento === department)?.ciudades || [])
    : [];

  const handleSubmit = (e) => {
    e.preventDefault();
    setFilters({
      companyName,
      department: department || null,
      city: city || null,
      categoryId: jobType?.value ?? null
    });
  };

  const handleDepartmentChange = (e) => {
    setDepartment(e.target.value);
    setCity("");
  };

  return (
    <React.Fragment>
      <form action="#">
        <Row className="g-2">
          <Col lg={3} md={6}>
            <div className="filler-job-form">
              <i className="uil uil-briefcase-alt"></i>
              <Input
                type="search"
                className="form-control filter-input-box"
                id="exampleFormControlInput1"
                placeholder="Nombre de la Empresa... "
                style={{ marginTop: "-10px" }}
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>
          </Col>
          <Col lg={2} md={6}>
            <div className="filler-job-form">
              <i className="uil uil-map-marker"></i>
              <select
                className="form-select form-control filter-input-box"
                style={{ marginTop: "-10px", border: 0, boxShadow: "none" }}
                value={department}
                onChange={handleDepartmentChange}
                aria-label="Departamento"
              >
                <option value="">Departamento</option>
                {departmentCityOptions.map((opt) => (
                  <option key={opt.id} value={opt.departamento}>
                    {opt.departamento}
                  </option>
                ))}
              </select>
            </div>
          </Col>
          <Col lg={2} md={6}>
            <div className="filler-job-form">
              <i className="uil uil-location-point"></i>
              <select
                className="form-select form-control filter-input-box"
                style={{ marginTop: "-10px", border: 0, boxShadow: "none" }}
                value={city}
                onChange={(e) => setCity(e.target.value)}
                aria-label="Ciudad"
                disabled={!department}
              >
                <option value="">Ciudad</option>
                {citiesForDepartment.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>
          </Col>
          <Col lg={2} md={6}>
            <div className="filler-job-form">
              <i className="uil uil-clipboard-notes"></i>
              <JobType value={jobType} onChange={(selectedOption) => setJobType(selectedOption)} />
            </div>
          </Col>
          <Col lg={3} md={6}>
            <Link to="#" className="btn btn-primary w-100" onClick={handleSubmit}>
              <i className="uil uil-filter"></i> Filtro
            </Link>
          </Col>
        </Row>
      </form>
    </React.Fragment>
  );
};

export default JobGridHeader;
